require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-sponsors-mozel-sanders-foundation-scholarships.json") })
        }
      }, "path---articles-financial-center-sponsors-mozel-sanders-foundation-scholarships");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-sponsors-mozel-sanders-foundation-scholarships!./.cache/json/articles-financial-center-sponsors-mozel-sanders-foundation-scholarships.json
// module id = 1676
// module chunks = 231608221292675